import React, {Component} from "react";
import { map, isEmpty, orderBy} from "lodash";
import moment from "moment-timezone";
import {DatePicker, message, Modal, Select} from "antd";
import * as yup from "yup";
import plus_icon_green from "../../../../Assets/images/add-circle-outline-green.svg";
import AllState from "../../../../Assets/data/stateList.json";
import BasicDetail from "./BasicDetail";
import SideBar from "./SideBar";
import visa from "../../../../Assets/images/visa_dark.svg";
import american from "../../../../Assets/images/american_express_dark.svg";
import chevronDown from '../../../../Assets/images/chevron-down.png';
import Loader from "../../../Common/Component/Loader";
import {errorHandle} from "../../../Common/errorHandle";
import TechnicianOutsideAlerter from "../../../Common/technicianOutsideAlerter";
import Axios from 'axios';

import { Promise } from "q";
const { Option } = Select;

// mapping contact method
const contact_methods = [
  {key: 'Text', value: 'text'},
  {key: 'Call Home Phone', value: 'home_phone'},
  {key: 'Call Mobile', value: 'mobile'},
  {key: 'Email', value: 'email'},
]

const invoice_preferences = [
  {key: 'Print Invoice', value: 'print_invoice_card'},
  {key: 'Email Invoice', value: 'email_invoice'},
]

const payment_methods = [
  {key: 'Cash or Check', value: 'cash_or_check'},
  {key: 'Credit Card', value: 'credit_card'},
]

const pre_payment_methods = [
  {key: 'Do not prepay', value: '0', text: 'Pay as and when invoices are sent'},
  {key: 'Prepay for 6 months', value: '6', text: 'Pay for the next 6 months and get 5% off'},
  {key: 'Prepay for 12 months', value: '12', text: 'Pay for the next 12 months and get 10% off'},
]

const preferred_service_days = [
  {key: 'Any Day', value: 'any'},
  {key: 'Sunday', value: 'sunday'},
  {key: 'Monday', value: 'monday'},
  {key: 'Tuesday', value: 'Tuesday'},
  {key: 'Wednesday', value: 'wednesday'},
  {key: 'Thursday', value: 'thursday'},
  {key: 'Friday', value: 'friday'},
  {key: 'Saturday', value: 'saturday'},
]

class BillingInfo extends Component 
{
  fattJs = null;

  constructor(props) 
  {
    super(props);
    this.state = {
      franchises: [],
      preferred_start_date: '',
      contactMethods: [],
      display_preferred_start_date: '',
      zipcodeCheck: null,
      charge_invoice_card: false,
      print_invoice_card: false,
      email_invoice: false,
      is_address_manually: false,
      isBillingAddress: true,
      address: {address: '', city: '', state: '', zip_code: '', address2:''},
      org_address: {address: '', city: '', state: '', zip_code: '',address2:''},
      isAgreed: true,
      is_btn_active: false,
      is_basic_btn_active: false,
      errors: {},
      cardList: {},
      isAddNewCard: false,
      user_billing_info_uuid: '',
      is_save: false,
      stripe_card_details: {},
      stax_public_apikey: '',
      hideAddNewButton: false ,
      fieldTechnicianFilter: [],
      pre_payment: '0',
      technician_uuid: '',
      payment_method: '',
      card_select: '',
      preferred_days: [],
      is_coupon_valid: false,
      isApplyCouponCode:false,
      coupon_code_error_message:[]
    }
    this.basicDetail = null;
    this.sidebar = null;
  }

  componentDidMount = () => {

    const basic_details_data = JSON.parse(sessionStorage.getItem('basicDetail'));
    this.props.getCardList({user__uuid: this.props?.customerId});
    this.props.getFieldTechnicianFilter();
    this.props.getFieldOfficeById({
      zip_code : basic_details_data?.zipcode,
      franchises_uuid : this.props?.zipcodeCheck?.data?.results?.[0].uuid,
    });

    this.setState({address:basic_details_data?.service_address});

    if (this.props && this.props?.zipcodeCheck && Object.keys(this.props?.zipcodeCheck?.data).length > 0) {
      this.setState({
        stax_public_apikey: (!isEmpty(this.props.zipcodeCheck)) && (!isEmpty(this.props.zipcodeCheck.data)) && (!isEmpty(this.props.zipcodeCheck.data.results)) ? this.props.zipcodeCheck.data?.results[0]?.stax_public_apikey : null,
        hideAddNewButton : (!isEmpty(this.props.zipcodeCheck)) && (!isEmpty(this.props.zipcodeCheck.data)) && (!isEmpty(this.props.zipcodeCheck.data.results)) ? false : true
      })
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => 
  {
    const {
      email_invoice,
      contactMethods,
      print_invoice_card,
      preferred_start_date
    } =this.state;

    ///////////// Error handle /////////////////////////
    if (Object.keys(nextProps?.zipcodeCheck?.errors).length > 0 && nextProps?.zipcodeCheck?.errors !== this.props?.zipcodeCheck?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.zipcodeCheck?.errors)
    }

    if (Object.keys(nextProps?.lead?.errors).length > 0 && nextProps?.lead?.errors !== this.props?.lead?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.lead?.errors)
    }

    if (Object.keys(nextProps?.AddCard?.errors).length > 0 && nextProps?.AddCard?.errors !== this.props?.AddCard?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.AddCard?.errors)
    }

    if (Object.keys(nextProps?.UpdateCard?.errors).length > 0 && nextProps?.UpdateCard?.errors !== this.props?.UpdateCard?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.UpdateCard?.errors)
    }

    if (Object.keys(nextProps?.DeleteCard?.errors).length > 0 && nextProps?.DeleteCard?.errors !== this.props?.DeleteCard?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.DeleteCard?.errors)
    }

    if (Object.keys(nextProps?.PricingCalc?.errors).length > 0 && nextProps?.PricingCalc?.errors !== this.props?.PricingCalc?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.PricingCalc?.errors)
    }
    if (Object.keys(nextProps?.ValidateCouponCode?.errors).length > 0 && nextProps?.ValidateCouponCode?.errors !== this.props?.ValidateCouponCode?.errors) {
      this.setState({loader: false});
      this.setState({ is_coupon_valid: false, coupon_code_error_message:nextProps?.ValidateCouponCode?.errors.coupon_code}, () => {});

      errorHandle(nextProps?.ValidateCouponCode?.errors);
    }

    ////////////////////////////////////////////////////////////////////////////////////

    if (Object.keys(nextProps?.serviceOrderEnquiry?.enquiryList).length > 0
      && JSON.stringify(this.state.enquiryList) !== JSON.stringify(nextProps?.serviceOrderEnquiry?.enquiryList)) {
      const order = nextProps?.serviceOrderEnquiry?.enquiryList?.results?.[0];
      const obj = {
        isBillingAddress: (order?.is_billing_address_same === undefined || order?.is_billing_address_same === null) ? true : order?.is_billing_address_same,
        // address:  !isEmpty(order) ? order?.is_billing_address_same ? order?.service_address : order?.billing_address : {address: '', city: '', state: '', zip_code: ''},
        address: order && order.billing_address ? order.billing_address : order?.service_address,
        org_address: order?.service_address,
        preferred_start_date: order?.preferred_start_date ? moment(order?.preferred_start_date).format('MM-DD-YYYY') : preferred_start_date ? preferred_start_date : '',
        contactMethods: order?.preferred_contact_methods.length > 0 ? order?.preferred_contact_methods : contactMethods.length > 0 ? contactMethods : [],
        charge_invoice_card: order?.charge_invoice_card,
        print_invoice_card: order?.is_print_and_mail_invoices || print_invoice_card || false,
        email_invoice: order?.is_email_invoice || email_invoice || false,
        user_billing_info_uuid: order?.user_billing_info?.uuid || '',
        stripe_card_details: order?.stripe_card_details || {},
        coupon_code: order?.coupon_code,
        payment_method: order?.payment_method_type || '',
        isAgreed:order?.preferred_contact_methods && order?.preferred_contact_methods.length > 0 ? true :false 
      }

      this.setState({...obj, enquiryList: nextProps?.serviceOrderEnquiry?.enquiryList}, () => {
      });
    }
     
    if (Object.keys(nextProps?.zipcodeCheck?.fieldOfficeDetail).length > 0
      && JSON.stringify(nextProps?.zipcodeCheck?.fieldOfficeDetail) !== JSON.stringify(this.state.franchises)) {
      this.setState({
        zipcodeCheck:true,
        loader: false,
        franchises: nextProps?.zipcodeCheck?.fieldOfficeDetail.data
      });
    }

    if (Object.keys(nextProps?.serviceOrderEnquiry?.nonServiceableEnquiry).length > 0
      && JSON.stringify(nextProps?.serviceOrderEnquiry?.nonServiceableEnquiry) !== JSON.stringify(this.props?.serviceOrderEnquiry?.nonServiceableEnquiry)) {
      this.setState({loader: false});
    }

    if (Object.keys(nextProps?.CardList?.data).length > 0
      && JSON.stringify(nextProps?.CardList?.data) !== JSON.stringify(this.state?.cardList)) {
      this.setState({loader: false, cardList: nextProps?.CardList?.data});
      if(nextProps?.serviceOrderEnquiry?.enquiryList?.results?.[0]?.user_billing_info){
        let selectedCard = nextProps?.CardList?.data.results.findIndex(card => card.uuid === nextProps?.serviceOrderEnquiry?.enquiryList?.results?.[0]?.user_billing_info?.uuid);
        this.setState({card_select:selectedCard >= 0 ? nextProps?.serviceOrderEnquiry?.enquiryList?.results?.[0]?.user_billing_info?.uuid : null })
      }
    }

    if (Object.keys(nextProps?.AddCard?.data).length > 0
      && JSON.stringify(nextProps?.AddCard?.data) !== JSON.stringify(this.props?.AddCard?.data)) {
      this.setState({loader: false});
      this.props.getCardList({user__uuid: this.props?.customerId})
    }

    //get field technician filters
    if (nextProps?.fieldTechnicianFilter && nextProps?.fieldTechnicianFilter?.technicianList && nextProps?.fieldTechnicianFilter?.technicianList?.results && Object.keys(nextProps?.fieldTechnicianFilter?.technicianList?.results).length > 0) {
      this.setState({ fieldTechnicianFilter: nextProps?.fieldTechnicianFilter?.technicianList?.results}, () => {
      });
    }

    // Check valid coupon 
    if (nextProps?.ValidateCouponCode && nextProps?.ValidateCouponCode?.validateCouponCode && nextProps?.ValidateCouponCode?.validateCouponCode?.is_coupon_valid && nextProps?.ValidateCouponCode?.validateCouponCode?.is_coupon_valid !== this.state.is_coupon_valid && this.state.coupon_code) {
      this.setState({ is_coupon_valid: nextProps?.ValidateCouponCode?.validateCouponCode?.is_coupon_valid,coupon_code_error_message:[]}, () => {
        // console.warn('is_coupon_valid', this.state.is_coupon_valid)
        this.onAddCoupon();
      });
    }

    if (this.state.hideAddNewButton) {
      message.error('Error occur while loading stax. please contact to admin.', 500);
    }

    this.setState({loader: false});
  }

  // validate basic detail
  validateBasicInfo = (value) => {
    const {is_basic_btn_active} = this.state;
    if (is_basic_btn_active !== value) {
      this.setState({is_basic_btn_active: value})
    }
  }

  // on billing info change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value })
  }

  // on preferred date changed
  onDataChange = (e) => {
    this.setState({
      preferred_start_date: e.target.checked ? e.target.value : '',
      display_preferred_start_date: null
    })
  }

  // on contact method changed
  onContactMethodChange = (e) => {
    const {contactMethods} = this.state;
    const idx = contactMethods?.indexOf(e.target.value);
    if (idx > -1) {
      contactMethods.splice(idx, 1);
    } else {
      contactMethods.push(e.target.value);
    }
    this.setState({contactMethods});
  };

  // Google Map Place API
  handleScriptLoad = () => {

    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address_1'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'formatted_address']);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', this.handlePlaceSelect);

    this.setState({
      autocomplete: newAutoComplete,
    })
  }

  removeEmpty = (obj) =>{
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => (v !== null && v?.trim() !== "")));
  }

  // on place change
  handlePlaceSelect = () => 
  {
    const address= document?.getElementById('google_address')?.value;
    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`,
      {
        params: this.removeEmpty({
          address,
          latlng: undefined,
          key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
        })
      }).then((res) => 
    {
      const addressObject = res?.data?.results[0];
      let obj = {};

      map(addressObject?.address_components, (item) => 
      {
        if (item?.types?.includes('administrative_area_level_2')) {
          obj = Object.assign(obj, { 'address': item.short_name })
        }
        if (item?.types?.includes('route')) {
          obj = Object.assign(obj, { 'route': item.short_name })
        }
        if (item?.types?.includes('street_number')) {
          obj = Object.assign(obj, { 'street_number': item.short_name })
        }
        if (item?.types?.includes('administrative_area_level_1')) {
          obj = Object.assign(obj, { 'state': item.short_name })
        }
        if (item?.types?.includes('locality')) {
          obj = Object.assign(obj, { 'city': item.long_name })
        }
        if (item?.types?.includes('postal_code')) {
          obj = Object.assign(obj, { 'zip_code': item.short_name })
        }
      });
      
      obj.address=`${obj?.street_number || ''} ${obj?.route || ''}`;

      this.setState({address: obj}, () => 
      {
        if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
          message.error('Please enter valid address');
        }
      });
    }).catch((err) => {
      console.log(err);
    });
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    console.log(((!isNaN(value) && reg.test(value)) || value === '' || value === '-'))
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  }

  // on billing value change
  onBillingOptionsChanged = (e) => {
    const { cardList , card_select} = this.state;
    const idx = cardList?.results?.findIndex(obj => obj.uuid === e);
    this.setState({
      cardList,
      address: cardList?.results?.[idx]?.address,
      card_select:cardList?.results?.[idx]?.uuid,
      user_billing_info_uuid: cardList?.results?.[idx]?.uuid,
      stripe_card_details: cardList?.results?.[idx]?.stripe_card_details,
    });
  }

  // on address change
  onAddressChange = (e) => {
    const {address} = this.state;

    Object.assign(address, {[e.target.name]: e.target.value});
    this.setState({address});
  };

  // card validation
  validate = (action) => {
    const {
      address,
      isAgreed,
      card_select,
      pre_payment,
      zipcodeCheck,
      contactMethods,
      payment_method,
      preferred_days,
      technician_uuid,
      isBillingAddress,
      user_billing_info_uuid,
    } = this.state;

    const schema = yup.object().shape({
      zipcodeCheck: yup.bool(),
      payment_method: yup.string().required('Please select a payment method.'),
      contactMethods: yup.array().required('Preferred contact methods is required.'),
      payment_method_card:  payment_method && payment_method !== "credit_card" && this.props.getPrePayData() ? yup.string().required('You must provide a card to process pre-payment.') : null,
      card_select: payment_method === "credit_card" ? yup.string().required('Please select a card.') : null,
      isAgreed: yup.bool().test('match', 'Field must be checked', (isAgreed) => {
        if (zipcodeCheck) return isAgreed
        return true
      }),
      isBillingAddress: yup.bool(),
      address: yup.object().when("isBillingAddress", {is: false, then: yup.object().shape({
        address: yup.string().required("Address is required"),
        state: yup.string().required("State is required"),
        city: yup.string().required("City is required"),
        zip_code: yup.string().required("Zipcode is required").min(5, 'Your ZIP code is invalid.'),
        address2:yup.string()
      })}),
    });

    const data = {
      address,
      isAgreed,
      card_select,
      zipcodeCheck,
      contactMethods,
      payment_method,
      isBillingAddress,
    };

    this.basicDetail.validate().then((res) => {
     
      if (res === 'success') {
        this.sidebar.leadValidate().then((sidebar_res) => {
          
          if (sidebar_res === 'success') {
            schema.validate(data, {abortEarly: false}).then(() => {
             
              this.setState({is_btn_active: true, errors: {}}, () => {
                
                this.storeInLocal();

                if (action === 'save') {
                  if (this.state.zipcodeCheck) {
                    this.setState({is_save: true}, () => this.onSaveLead());
                  } else {
                    this.props.onNonServiceableEnquiry();
                  }
                } else if (action === 'next') {
                  if (this.state.zipcodeCheck) {
                    this.setState({is_save: false}, () => this.commonApiCallsConvertCustomer());
                  } else {
                    this.props.onNonServiceableEnquiry();
                  }
                }
              });
            }).catch((error) => {
              let err_data = {};
              map(error?.inner, (item) => {
                err_data[item.path] = item.message
              });
              this.setState({errors: err_data, is_btn_active: false});
            });
          }
        }); //end of callback validation
      }
    });// end of basic detail validation
  }

  // common api call for convert to customer
  commonApiCallsConvertCustomer = () => {

    const basicDetail = JSON.parse(sessionStorage.getItem('basicDetail'));
    
    Promise.all([this.props.onConvertToCustomer(), this.props.addCallLog()]).then((result) => {
      
      const isReject = result.filter(x => x.status === "rejected");

      if (isReject?.length > 0) {
        setTimeout(() => errorHandle(isReject?.[0]?.reason), 1000);
      } else {
        setTimeout(() => this.props.history.replace('/residential/dog-info', 
          { query: { 'id': this.props.customerId, zipcode: basicDetail?.zipcode } }), 2000);
      }
    });
  }

  // store data in local
  storeInLocal = () => {
    const {
      isBillingAddress,
      address,
      preferred_start_date,
      contactMethods,
      isAgreed,
      charge_invoice_card,
      user_billing_info_uuid,
      print_invoice_card,
      email_invoice,
      payment_method
    } = this.state;

    sessionStorage.setItem("step2", JSON.stringify({
      isBillingAddress,
      address,
      preferred_start_date: moment(preferred_start_date).format('YYYY-MM-DD'),
      contactMethods,
      isAgreed,
      charge_invoice_card,
      print_invoice_card,
      email_invoice,
      user_billing_info_uuid,
      payment_method
    }));
  }

  // on save lead
  onSaveLead = () => {
    this.storeInLocal();
    this.commonApiCallsSaveLead();
  };

  // common api call for save lead
  commonApiCallsSaveLead = (e = {}) => {
    Promise.all([this.props.addCallLog(), 
      setTimeout(() => this.props.onAddEnquiry('step2', e),1000)]
    ).then((result) => {

      const isReject = result.filter(x => x.status === "rejected");
      this.setState({loader: false});

      if (isReject?.length > 0) {
        setTimeout(() => errorHandle(isReject?.[0]?.reason), 1000);
      } else {
        this.setState({loader: true});
        setTimeout(() => {
          if (this.state.is_save) 
          {
            this.props.getServiceOrderEnquiry({user__uuid: this.props?.customerId, limit: 1}); // get service order enquiry
            this.props.history.goBack();
            this.setState({is_save: false, loader: false});
          }
        }, 2000);
      }
    })
  }

  // card validation
  validation = () => {
    const {
      card_number,
      card_expiry_month,
      card_expiry_year,
      card_cvv
    } = this.state;

    const cardSchema = yup.object().shape({
      card_number : this.fattJs.validNumber ? null : yup.string().nullable().required('Card Number is required'),
      card_expiry_month : yup.string().nullable().required('Card expire month is required'),
      card_expiry_year : yup.string().nullable().required('Card expire year is required').min(4, 'Card expire year is invalid.').max(4, 'Card expire year is invalid.'),
      card_cvv : this.fattJs.validCvv ? null : yup.string().nullable().required('Card CVC is required'),
      // isBillingAddress: yup.bool(),
      // address: yup.object().when("isBillingAddress", {is: false, then: yup.object().shape({
      //   address: yup.string().required("Address is required"),
      //   state: yup.string().required("State is required"),
      //   city: yup.string().required("City is required"),
      //   zip_code: yup.string().required("Zipcode is required").min(5, 'Your ZIP code is invalid.')
      // }) }),
    })

    const cardData = {
      card_number,
      card_expiry_month,
      card_expiry_year,
      card_cvv 
    };

    cardSchema.validate(cardData, { abortEarly: false }).then(() => {
      this.setState({errors: {}, loader: true}, () => {
        this.addNewCard();
      })
    }).catch((error) => {
      let err_data = {};
      map(error?.inner, (item) => {err_data[item.path] = item.message});
      this.setState({errors: err_data});
    });

  }

  // on add card
  addNewCard = () => {
    const { card_number, card_expiry_month, card_expiry_year } = this.state;
    const basicDetail = JSON.parse(sessionStorage.getItem('basicDetail'));
    const step2Data = JSON.parse(sessionStorage.getItem('step2'));
    const service_address = (basicDetail?.address?.street_number && basicDetail?.address?.route) ? {...basicDetail?.address, address: `${basicDetail?.address?.street_number} ${basicDetail?.address?.route}`} : basicDetail?.address;
    const billing_address = (step2Data?.address?.street_number && step2Data?.address?.route) ? {...step2Data?.address, address: `${step2Data?.address?.street_number} ${step2Data?.address?.route}`} : step2Data?.address;
    const card_address = !step2Data ? service_address : step2Data?.isBillingAddress ? service_address : billing_address;
    const stax_customer = (!isEmpty(this.props.lead)) && (!isEmpty(this.props.lead.updateLead)) && (!isEmpty(this.props.lead.updateLead.stax_customer)) ? this.props.lead.updateLead.stax_customer : null;

    if (!card_address.geo_location) {
      delete card_address.geo_location;
    }

    this.setState({ loader : true });

    const token_obj = {
      address_1: card_address ? card_address.address : null,
      address_city: card_address ? card_address.city : null,
      address_state: card_address ? card_address.state : null,
      address_zip: card_address ? card_address.zip_code : null,
      month : card_expiry_month ? card_expiry_month : null,
      year : card_expiry_year ? card_expiry_year : null,
      card_number: card_number ? card_number : null,
      email: basicDetail && basicDetail.leadData ? basicDetail.leadData.email : null,
      firstname: basicDetail && basicDetail.leadData && basicDetail.leadData.first_name !== "" ? basicDetail.leadData.first_name : basicDetail.firstName,
      lastname: basicDetail && basicDetail.leadData && basicDetail.leadData.last_name !== "" ? basicDetail.leadData.last_name : basicDetail.lastName,
      method: 'card',
      person_name: basicDetail ? `${basicDetail.leadData.first_name} ${basicDetail.leadData.last_name}` : null,
      phone: this.state.card_phone
    };

    if (stax_customer) {
      token_obj['customer_id'] = stax_customer;
    }
 
    this.fattJs.tokenize(token_obj).then((res) => {
      if (res && Object.keys(res).length > 0) {
        this.props.addNewCard({
          'user_uuid': this.props.customerId ? this.props.customerId : basicDetail?.leadData?.uuid,
          'stax_card_token' : res['id'] || null,
          'address': card_address,
          'card_holder_name': basicDetail ? `${basicDetail.firstName} ${basicDetail.lastName}` : null,
          'charge_invoice_card': step2Data ? step2Data.charge_invoice_card : false,
          'print_invoice_card': step2Data ? step2Data.print_invoice_card : false,
          'email_invoice': step2Data ? step2Data.email_invoice : false,
        });

        setTimeout(() => this.setState({isAddNewCard: false}), 1000);
      }
    }).catch((err) => {
      this.setState({ loader : false });

      map(err.fieldErrors, (item) => { message.error(item.message,10) });

      console.error("Error : ",err);
      message.error(err.message,10);
    });
  };

  onCancel = () => {
    this.props.history.goBack();
    sessionStorage.removeItem('step1');
    sessionStorage.removeItem('step2');
    sessionStorage.removeItem('logCall');
    sessionStorage.removeItem('calcData');
    sessionStorage.removeItem('pricingCalc');
    sessionStorage.removeItem('basicDetail');
  }

  // render all state
  renderAllState = () => {
    return AllState.AllState.map((item, i) => {
      return (<Option value={item.abbreviation} key={i}>{item.name}</Option>);
    });
  }

  // render extra footer
  renderExtraFooter = () => {
    return (
      <div className="data_indicator">
        <a
          href="/#"
          onClick={(e) => { e.preventDefault() }}
          className="btn"
        >Available</a>
        <a
          href="/#"
          onClick={(e) => { e.preventDefault() }}
          className="btn unavailable"
        >Unavailable</a>
      </div>
    );
  }
 
  // render add card modal
  renderAddCardModal = () => {
    const {isAddNewCard, errors} = this.state;
    
    return (
      <Modal
        title="Add New Card"
        visible={isAddNewCard}
        onCancel={() => { this.setState({isAddNewCard: false}) }}
        footer={[
          <button
            key="cancel"
            className="btn btn-brand btn-bdr"
            onClick={() => {this.setState({isAddNewCard: false})
            }}>Cancel</button>,
          <button
            key="submit"
            className={`btn btn-warning`}
            onClick={() => this.validation()}
          >Save</button>
        ]}
      >
        <div>
          <div className={"flex mt-10"}>
            <div className={"flex-1"}>
              <div className="form-group">
                <div className="fitem">
                  <label>Card Number<sup>*</sup></label>
                  <div id="card-number" className="form--control"></div>
                  {errors?.['card_number'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_number']}</label> : ''}
                </div>

                <div className="fitem">
                  <label>CVV<sup>*</sup></label>
                  <div id="card-cvv" className="form--control"></div>
                  {errors?.['card_cvv'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_cvv']}</label> : ''}
                </div>

                <div className="half-fitem fitem">
                  <div className="half-fitem fitem">
                    <label>Exp Month<sup>*</sup></label>
                    <input type="text" className="form--control" placeholder="MM" maxLength={2} 
                      inputMode="numeric"
                      onPaste={(event) => {
                        if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                          event.preventDefault();
                        }
                      }}
                      onKeyPress={(e) => {
                        const pattern = /[0-9]/;
                        const inputChar = String.fromCharCode(e.charCode);
                        if (!pattern.test(inputChar)
                        ) {
                          // invalid character, prevent input
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => { this.setState({ card_expiry_month: e.target.value }) }} 
                    />
                    {errors?.['card_expiry_month'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_expiry_month']}</label> : ''}
                  </div>
                  <div className="half-fitem fitem">
                    <label>Exp Year<sup>*</sup></label>
                    <input type="text" className="form--control" placeholder="YYYY" maxLength={4} 
                      inputMode="numeric"
                      onPaste={(event) => {
                        if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                          event.preventDefault();
                        }
                      }}
                      onKeyPress={(e) => {
                        const pattern = /[0-9]/;
                        const inputChar = String.fromCharCode(e.charCode);
                        if (!pattern.test(inputChar)
                        ) {
                          // invalid character, prevent input
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => { this.setState({ card_expiry_year: e.target.value }) }} 
                    />
                    {errors?.['card_expiry_year'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_expiry_year']}</label> : ''}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  loadStax = () => {
    this.setState({ is_edit_info: true, can_edit: false, isAddNewCard: true });    
    const { stax_public_apikey } = this.state;
    if (stax_public_apikey) {
      const FattJs = window.FattJs;
      const fattJs = new FattJs(stax_public_apikey, {
        number: {
          id: "card-number",
          placeholder: "Card Number",
          style: "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;" // 35px is the height of my card-number div
        },
        cvv: {
          id: "card-cvv",
          placeholder: "CVV",
          style: "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;" // 35px is the height of my card-cvv div
        }
      });
      fattJs.showCardForm().then(handler => {
        console.log('form loaded', handler);
      }).catch(err => {
        console.error('error occur', err);
      });
      this.fattJs = fattJs;
    } else {
      message.error('Error occur while loading stax. please contact to admin.', 10);
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3294></DP-3294>
   * Validate Coupon
   */
  validateCoupon = () => {
    const { coupon_code } = this.state;
    const { updateLead } = this.props.lead;
    this.setState({isApplyCouponCode:true});
    const cardSchema = yup.object().shape({
      coupon_code: yup.string().required("Enter a coupon code.")
    })
    const cardData = { coupon_code };
    cardSchema.validate(cardData, { abortEarly: false }).then(() => {
      this.setState({errors: {}});
      this.props.validateCoupon({
        coupon_code: coupon_code,
        email: updateLead.email
      });
    }).catch((error) => {
      let err_data = {};
      map(error?.inner, (item) => {err_data[item.path] = item.message})
      this.setState({errors: err_data});
    });
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3294></DP-3294>
   */
  onAddCoupon = () => {
    const {coupon_code, prepay_months, isPrePay} = this.state;
    this.props.setCouponCode && this.props.setCouponCode(coupon_code)
    sessionStorage.setItem('calcData', JSON.stringify({coupon_code, prepay_months, isPrePay}))
    this.props.priceCalc({coupon_code, prepay_months, isPrePay});
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3294></DP-3294>
   */
  onClearCoupon = () => {
    this.setState({ coupon_code: '', is_coupon_valid: false, coupon_code_error_message:[],isApplyCouponCode:false}, () => {
      const {coupon_code, prepay_months, isPrePay} = this.state;
      sessionStorage.setItem('calcData', JSON.stringify({coupon_code, prepay_months, isPrePay}))
      // if (pricingCalc) sessionStorage.setItem('PricingCalc', JSON.stringify(pricingCalc))
      this.props.priceCalc({coupon_code, prepay_months, isPrePay})
    });    
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3294></DP-3294>
   */
  onEnter = (event) => {
    if (event.key === "Enter") {
      this.onAddCoupon();
    }
  }

  onServiceDaysChanged = (e, index) => {
    const { preferred_days, allServiceDaysSelected } = this.state;
    let arrServiceDays = [...preferred_days];
    if (e.target.checked) {
      if (index === null) {
        arrServiceDays = [];
        preferred_service_days.forEach(element => {
          element['is_change'] = !allServiceDaysSelected;
          if(!allServiceDaysSelected) {
            arrServiceDays.push(element?.value);
          }
        });
      } else {
        if (arrServiceDays.indexOf(e.target.id) === -1) {
          arrServiceDays.push(e.target.id)
          preferred_service_days[index]['is_change'] = true;
        }
      }
    } else {
      if (index === null) {
        arrServiceDays = [];
        preferred_service_days.forEach(element => {
          element['is_change'] = false
        });
      } else {
        const ind = arrServiceDays.indexOf(e.target.id);
        if (ind > -1) {
          arrServiceDays.splice(ind, 1);
          preferred_service_days[index]['is_change'] = false;
        }
      }
    }
    this.setState({ preferred_days: arrServiceDays, allServiceDaysSelected: index === null ? !allServiceDaysSelected : false },() => {
      // console.warn('technician__uuid', this.state.technician__uuid);
    });    
  }

  closeTechnicianFilter = () => {
    this.setState({ toggleServiceDaysFilter: false })
  }

  getSelectedArray = () => {
    const toString = this.state.preferred_days && this.state.preferred_days.length ? this.state.preferred_days.toString().split(',').join(', ') : null;
    return toString;
  }

  toggleServiceDays = () => {
    const { toggleServiceDaysFilter } = this.state;
    if (toggleServiceDaysFilter) {
      this.setState({ toggleServiceDaysFilter: false })
    } else {
      this.setState({ toggleServiceDaysFilter: true, toggleServiceOrderFilter: false,     toggleWorkOrderFilter: false, toggleStatusFilter: false })
    }
  }
  
  renderServiceDaysFilters =  () => {
    const { toggleServiceDaysFilter, preferred_days } = this.state;
    return (
      <TechnicianOutsideAlerter
        closeTechnicianFilter={this.closeTechnicianFilter}
      >
        <div className="form-group image-input custom-preferred-days-dropdown ">
          <div className="fitem">
            <div className="cpreferred-input">
              <input type="text" id="txtTechnician" placeholder=""  onFocus={() => {this.toggleServiceDays() }} />
              <label className="lbl-list"  htmlFor=""> {preferred_days && preferred_days.length === 0 ? 'Any' : this.getSelectedArray()}
              </label>

            </div>  
            {preferred_days && preferred_days.length === 0 && 
              <img src={chevronDown} alt="" onClick={() => { this.toggleServiceDays() }} />
            }
          </div>
          {toggleServiceDaysFilter && <div className="field-dropdown custom-preferred-days">
            <div className="field-dropdown-body">
              {
                map(preferred_service_days, (item, index) => {
                  return (
                    <div key={index} className="fitem-check">
                      <input id={item?.value} type="checkbox" className="fitem-ck-input" onChange={(e) => { this.onServiceDaysChanged(e, index)}} checked={item.is_change} />
                      <label htmlFor={item?.value} className="fitem-ck-txt">{item?.key}</label>
                    </div>
                  )
                })}
            </div>
          </div>}
        </div>
      </TechnicianOutsideAlerter>
    );
  }

  render = () => {
    const {
      errors,
      loader,
      address,
      isAgreed,
      cardList,
      franchises,
      coupon_code,
      pre_payment,
      card_select,
      zipcodeCheck,
      email_invoice,
      payment_method,
      preferred_days,
      contactMethods,
      technician_uuid,
      is_coupon_valid,
      isBillingAddress,
      isApplyCouponCode,
      print_invoice_card,
      charge_invoice_card,
      preferred_start_date,
      fieldTechnicianFilter,
      coupon_code_error_message,
      display_preferred_start_date,
    } = this.state;
    const {onTabChange} = this.props;

    return (
      <div className="container">
        {loader && <Loader />}
        <div className="fluid-block">
          <div className="article-block">
            <BasicDetail
              ref={(ref) => this.basicDetail = ref}
              customerId={this.props.customerId}
              currentTab={this.props.currentTab}
              validateBasicInfo={this.validateBasicInfo}
              // reducers
              zipcodeCheck={this.props.zipcodeCheck}
              lead={this.props.lead}
              DeletePhoneNumber={this.props.DeletePhoneNumber}
              GoogleApi={this.props.GoogleApi}
              // apis
              getLeadById={this.props.getLeadById}
              checkZipCode={this.props.checkZipCode}
              resetCheckZipcode={this.props.resetCheckZipcode}
              deletePhoneNumber={this.props.deletePhoneNumber}
              getGeocodeAddress={this.props.getGeocodeAddress}
              resetGeocodeAddress={this.props.resetGeocodeAddress}
              changeInfo={true}
            />
            <div className={`adetail ${zipcodeCheck ? '' : 'disabled'}`}>
              <h3 style={{marginTop: "10px"}}>Work Order Information</h3>
              <div className="form-block">
                
                {/* Preferred Start Date Block */}
                <div className="frow">
                  <label>Preferred Start Date</label>
                  <div className="oplist">
                    {/*render date list*/}
                    {map(franchises?.sort()?.slice(0, 3), (item, i) => {
                      return (
                        <div className="inline-checks flex-1" key={`preferred_start_dates${i}`}>
                          <label htmlFor={item?.value} className={preferred_start_date === item ? 'active' : ''}>
                            <input
                              type="radio"
                              id={item?.value}
                              name="preferred_start_date"
                              disabled={!zipcodeCheck}
                              checked={preferred_start_date === item}
                              value={item}
                              className=""
                              onChange={(e) => { this.onDataChange(e) }}
                            />
                            <span>{moment(item, "MM-DD-YYYY").format('ddd, MMM DD')}</span>
                          </label>
                        </div>
                      )})}
                    <div className="inline-checks flex-1">
                      <DatePicker
                        renderExtraFooter={() => this.renderExtraFooter()}
                        inputReadOnly
                        mode={'date'}
                        className={display_preferred_start_date ? 'active' : 'box_opacity'}
                        disabled={!zipcodeCheck}
                        placeholder={'Select another date'}
                        format={"ddd, MMM DD"}
                        value={display_preferred_start_date}
                        onChange={(e) => {
                          this.setState({
                            display_preferred_start_date: e,
                            preferred_start_date: moment(e).format('MM-DD-YYYY')
                          });
                        }}
                        disabledDate={current => {
                          return !franchises?.sort()?.slice(3, franchises.length).includes(moment(current).format('MM-DD-YYYY'))
                        }}
                      />
                    </div>
                    {errors?.['preferred_start_date'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['preferred_start_date']}</label> : ''}
                  </div>
                </div>

                {/* Contact Method Block */}
                <div className="frow ">
                  <label>Contact Method</label>
                  <div className="oplist">
                    {map(contact_methods, (item, index) => {
                      const isInclude = contactMethods?.includes(item?.value);
                      return (
                        <div className="inline-checks flex-1" key={`contactMethod${index}`}>
                          <label htmlFor={item?.value} className={isInclude ? 'active' : ''}>
                            <input
                              type="checkbox" 
                              id={item?.value} 
                              name='contactMethod' 
                              disabled={!zipcodeCheck} 
                              className="" 
                              value={item?.value} 
                              onChange={(e) => this.onContactMethodChange(e)}
                            />
                            <span>{item?.key}</span>
                          </label>
                        </div>
                      )
                    })}
                  </div>
                  {errors?.['contactMethods'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['contactMethods']}</label> : ''}
                </div>

                {/* Invoice Preferences Block */}
                <div className="frow">
                  <label>Invoice Preferences </label>
                  <div className="oplist">
                    {map(invoice_preferences, (item, index) => {
                      const isInclude = contactMethods?.includes(item?.value);
                      return (

                        <div className="inline-checks flex-1" key={`contactMethod${index}`}>
                          <label
                            htmlFor={item?.value} 
                            className={(item?.value === 'print_invoice_card' && this.state.print_invoice_card) ? 'active' : (item?.value === 'email_invoice' && this.state.email_invoice) ? 'active' : ''  }
                          >
                            <input 
                              type="checkbox" 
                              id={item?.value} 
                              name={item?.value} 
                              value={item?.value}
                              onChange={(e) => {
                                if (e.target.value === 'print_invoice_card') {
                                  this.setState({ print_invoice_card: e?.target?.checked }, () => {
                                  });
                                }
                                if (e.target.value === 'email_invoice') {
                                  this.setState({ email_invoice: e?.target?.checked }, () => {
                                  });
                                }
                              }}
                            />
                            <span>{item?.key}</span>
                          </label>
                        </div>
                      )
                    })}
                  </div>
                </div>
                
                {/* Preferred Service Days Block */}
                {/* <div className="frow md-label">
                  <div className="pi-block">
                    <div className="field-group">
                      <label>Preferred Service Days <sup>*</sup></label>
                      {this.renderServiceDaysFilters()}
                    </div>
                  </div>
                  {errors?.['preferred_days'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['preferred_days']}</label> : ''}
                </div> */}




                {/* <div className="frow md-label">
                  <div className="pi-block">
                    <div className="field-group">
                      <label>Preferred Service Days <sup>*</sup></label>
                      <Select
                        value={preferred_days || []}
                      >
                        {map(preferred_service_days, (item, index) => {
                          return (
                            <Option key={index} value={item.value}>{item.key}</Option>
                          )
                        })}
                      </Select>
                    </div>
                  </div>
                </div> */}




                {/* Preferred Technician Block */}
                {/* <div className="frow md-label">
                  <div className="pi-block">
                    <div className="field-group">
                      <label>Preferred Technician <sup>*</sup></label>
                      <Select
                        showSearch
                        optionFilterProp="children"
                        placeholder="Any"
                        value={technician_uuid || undefined}
                        onChange={(e) => {
                          this.setState({technician_uuid:e})
                        }}
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {map(fieldTechnicianFilter, (item, index) => {
                          return (
                            <Option key={index} value={item.uuid}>{item?.user?.first_name}, {item?.user?.last_name}</Option>
                          )
                        })}
                      </Select>
                    </div>
                    {errors?.['technician_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['technician_uuid']}</label> : ''}
                  </div>
                </div> */}
                <hr />
                
                {/* Billing Address Block */}
                <div className="frow pt-10 ">
                  <h3>Billing Address</h3>
                  <div className="max-w-328">
                    <div className="fitem-check mt-10 mb-10">
                      <input 
                        type="checkbox" 
                        className="fitem-ck-input" 
                        id="isBillingAddress" 
                        checked={isBillingAddress} 
                        name="isBillingAddress" 
                        value={isBillingAddress} 
                        onChange={(e) => {
                          this.setState({isBillingAddress: e.target.checked}, () => {
                            if (this.state.isBillingAddress) {
                              this.setState({address: this.state.org_address})
                            } else {
                              this.setState({address: {address: '', state: '', city: '', zip_code: ''}})
                            }
                          })
                        }}
                      />
                      <label htmlFor="isBillingAddress" className="fitem-ck-txt">Same as Service Address</label>
                    </div>
                    <div className="form-group mb-20">
                      <div className="fitem">
                        <input
                          type="text"
                          placeholder="Address"
                          name="address"
                          value={address?.address}
                          onChange={(e) => this.onAddressChange(e)}
                        />
                        {errors?.['address.address'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['address.address']}</label> : ''}
                      </div>
                      <div className="fitem">
                        <input
                          type="text"
                          placeholder="Address Line 2 (Optional)"
                          name="address2"
                          value={address?.address2 || ''}
                          onChange={(e) => this.onAddressChange(e)}
                        />
                      </div>
                      <div className="half-fitem fitem">
                        <div className="half-fitem fitem">
                          <input
                            type="text"
                            placeholder="City"
                            name="city"
                            value={address?.city}
                            onChange={(e) => this.onAddressChange(e)}
                          />
                          {errors?.['address.city'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['address.city']}</label> : ''}
                        </div>
                        <div className="half-fitem fitem">
                          <Select
                            showArrow={true}
                            name="state"
                            placeholder="State"
                            onChange={(value) => this.onAddressChange({target: {name: 'state', value: value}})}
                            value={address?.state || undefined}
                            virtual={false}
                          >
                            {this.renderAllState()}
                          </Select>
                          {errors?.['address.state'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['address.state']}</label> : ''}
                        </div>
                        <div className="half-fitem fitem">
                          <input
                            type="text"
                            className='form--control'
                            placeholder="ZIP Code"
                            name="zip_code"
                            maxLength={5}
                            minLength={5}
                            onChange={(e) => this.onNumericInputChange(e.target.value) && this.onAddressChange(e)}
                            value={address?.zip_code || ''}
                          />
                          {errors?.['address.zip_code'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['address.zip_code']}</label> : ''}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr/>
                {/* Payment Information Block */}
                <div className="frow pt-10">
                  <h3>Payment Information</h3>
                  <div className="pi-block max-w-328">
                    
                    {/* Pre-Payment Block */}
                    {/* <div className="field-group">
                      <label>Pre-Payment <sup>*</sup></label>
                      <Select
                        placeholder={"Select Prepay"}
                        value={pre_payment || undefined}
                        onChange={(e) => {
                          this.setState({pre_payment : e});
                        }}
                      >
                        {map(pre_payment_methods, (item, index) => {
                          return (
                            <Option key={index} value={item.value}>
                              <React.Fragment>
                                <span>{item.key}</span><br />
                                <span>{item.text}</span>
                              </React.Fragment>
                            </Option>
                          )
                        })}
                      </Select>
                    </div> */}

                    {/* Add Coupon Block */}
                    <div className="field-group">
                      <label>Add Coupon</label>
                      <div className="flex">
                        <input 
                          type="text" 
                          className="flex-1" 
                          name="coupon_code"
                          placeholder={"Add Coupon"} 
                          value={coupon_code || ''} 
                          onChange={(e) => this.setState({ [e.target.name]: e.target.value,isApplyCouponCode:false })}
                          onKeyUp={this.onEnter.bind(this)}
                        />
                        {/* disabled */}
                        {!is_coupon_valid && 
                          <button type="button" className="coupne-btn btn p-10 ml-10" onClick={(e) => {this.validateCoupon()} }>Apply</button>
                        }
                        {is_coupon_valid && 
                          <button type="button" className="coupne-btn btn p-10 ml-10" onClick={(e) => {this.onClearCoupon()} }>Clear</button>
                        }
                      </div>
                      {!is_coupon_valid && coupon_code && isApplyCouponCode && coupon_code_error_message && coupon_code_error_message.length > 0 &&   <label className="has_err_msg"><i className="las la-times" /> Invalid coupon code</label>}
                      {is_coupon_valid && coupon_code && isApplyCouponCode && <label className="has_success_msg"><i className="las la-check"></i> Coupon applied</label>}


                      {errors?.['coupon_code'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['coupon_code']}</label> : ''}
                    </div>

                    {/* Payment Method Block */}
                    <div className="field-group">
                      <label>Payment Method <sup>*</sup></label>
                      <div className="mb-10">
                        <Select
                          placeholder="Select"
                          value={payment_method || undefined}
                          onChange={(e) => { 
                            this.setState({payment_method: e});
                          }}
                        >
                          {map(payment_methods, (item, index) => {
                            return (
                              <Option key={index} value={item.value}>{item.key}</Option>
                            )
                          })}
                        </Select>
                        {errors?.['payment_method'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['payment_method']}</label> : ''}
                        {errors?.['payment_method_card'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['payment_method_card']}</label> : ''}
                      </div>
                      {payment_method === "credit_card" ? <div>
                        <Select
                          disabled={cardList && cardList?.results?.length === 0}
                          placeholder="Select"
                          value={card_select || undefined}
                          onChange={(e) => this.onBillingOptionsChanged(e)}
                        >
                          {map(orderBy(cardList?.results, 'uuid', 'asc'), (item, index) => {
                            return (
                              <Option key={index} value={item?.uuid}>
                                <React.Fragment>
                                  <div className="card_img flex ai-center flex-1 ml-10">
                                    {JSON.parse(item.stax_payment_object).card_type === 'visa' ?
                                      <img height="25" src={visa} alt="" /> :
                                      <img height="25" src={american} alt="" />
                                    } &nbsp;&nbsp;
                                    <div className={'flex-1'}>
                                      <div>
                                        <label className="m-0">{!isEmpty(JSON.parse(item.stax_payment_object)) ? `${JSON.parse(item.stax_payment_object).card_type} ending in ${JSON.parse(item.stax_payment_object).card_last_four}` : ''}</label>
                                      </div>
                                    </div>
                                  </div>
                                </React.Fragment>
                              </Option>
                            )
                          })}
                        </Select>
                        {errors?.['card_select'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['card_select']}</label> : ''}
                      </div> : ''}
                    </div>
                    
                    {payment_method === "credit_card" ? <div className="fitem-check mt-10">
                      <input 
                        type="checkbox" 
                        className="fitem-ck-input"
                        checked={charge_invoice_card} 
                        id="charge" 
                        name="charge_invoice_card" 
                        value={charge_invoice_card}
                        onChange={(e) => this.onTextChange(e, 'bool')}
                      />
                      <label htmlFor="charge" className="fitem-ck-txt">Charge invoices to card</label>
                    </div> : ''}
                    { payment_method === "credit_card" ? 
                      <a
                        className="flex ai-center justify-content-start"
                        onClick={() => this.loadStax() }
                      ><img className="icoimg ml-0 mr-5" src={plus_icon_green} alt="" /> <strong>Add Card</strong>
                      </a> : ''
                    }
                  </div>
                </div>
                <hr style={{margin:'20px 0'}}/>
                {/* <div className="frow md-label">
                  <h4>Payment Information</h4>
                  <span>Accounts are charged the beginning of each month for service provided the prior month.</span>
                  {this.renderCardList()}
                  {errors?.['user_billing_info_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['user_billing_info_uuid']}</label> : ''}
                </div>
                <hr/> */}
                <div className="frow">
                  <h4> Terms of Service</h4>
                  {/*TODO: Add or delete Terms of Service link */}
                  <span>By signing up, I grant my permission for DoodyCalls to access my property and agree to the  full DoodyCalls <a href="/#">Terms of Service</a> and <a href="https://www.doodycalls.com/privacy-policy/">Privacy Policy.</a></span>
                  <div className="fitem-check mt-10">
                    <input type="checkbox" className="fitem-ck-input" disabled={!zipcodeCheck} id="isAgreed" name="isAgreed" checked={isAgreed} onChange={(e) => this.onTextChange(e, 'bool')} />
                    <label htmlFor="isAgreed" className="fitem-ck-txt">Customer verbally agreed</label>
                  </div>
                  {errors?.['isAgreed'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['isAgreed']}</label> : ''}
                </div>
              </div>
            </div>
            {/*{this.renderAddCardDrawer()}*/}
            {this.renderAddCardModal()}
          </div>
          <SideBar
            ref={(ref) => this.sidebar = ref}
            customerId={this.props.customerId}
            coupon_code={this.state.coupon_code}
            // reducers
            zipcodeCheck={this.props.zipcodeCheck}
            PricingCalc={this.props.PricingCalc}
            CallLog={this.props.CallLog}
            //
            getCallLogList={this.props.getCallLogList}
            priceCalc={this.props.priceCalc}
            currentTab={this.props.currentTab}
            serviceOrderEnquiry={this.props.serviceOrderEnquiry}
            RepresentativeList={this.props.RepresentativeList} // reducer
            getRepresentativeList={this.props.getRepresentativeList}
          />
        </div>
        <div className="fix-btn-grp">
          <button className="btn btn-white" onClick={() => this.onCancel()}>Cancel</button>
          <button className={`btn btn-warning`} onClick={() => this.validate('save') }>Save Lead</button>
          {zipcodeCheck ? 
            <button
              className={`btn btn-warning`}
              onClick={() => this.validate('next')}
            >Convert To Customer</button> : ''}
        </div>
      </div>
    )
  }
}

export default BillingInfo;